"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./header-export-button.component.scss");
var operators_1 = require("rxjs/operators");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var store_1 = require("@ngrx/store");
var idm_export_client_js_1 = require("@synisys/idm-export-client-js");
var Observable_1 = require("rxjs/Observable");
var noop_1 = require("rxjs/util/noop");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var lodash_1 = require("lodash");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var utilities_1 = require("../utilities");
var material_1 = require("@angular/material");
var delete_confirm_dialog_component_1 = require("../delete-confirm-dialog/delete-confirm-dialog.component");
var of_1 = require("rxjs/observable/of");
var template_utilities_1 = require("./template.utilities");
var helper_directive_1 = require("../helper.directive");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var export_copy_template_dialog_component_1 = require("./export-copy-template/export-copy-template-dialog.component");
var export_data_loader_service_1 = require("./export-data-loader.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var templates_additional_filter_service_1 = require("./templates-additional-filter.service");
var LOGGER = utilities_1.createLogger('header-export-button.component');
var HeaderExportButtonComponent = /** @class */ (function () {
    function HeaderExportButtonComponent(store, exportTemplatesService, exportService, authenticationService, authorizationService, exportDataLoader, templatesAdditionalFilter, matDialog) {
        this.store = store;
        this.exportTemplatesService = exportTemplatesService;
        this.exportService = exportService;
        this.authenticationService = authenticationService;
        this.authorizationService = authorizationService;
        this.exportDataLoader = exportDataLoader;
        this.templatesAdditionalFilter = templatesAdditionalFilter;
        this.matDialog = matDialog;
        this.classNameMap = {
            DOCX: 'dc-export-menu__title--word',
            RTF: 'dc-export-menu__title--word',
            XLS: 'dc-export-menu__title--excel',
            PDF: 'dc-export-menu__title--pdf',
        };
        this.selectedIndex = 0;
        this.actionType = 'DOWNLOAD';
        this._exportEditPermissionGranted = false;
        this.allActionsTypes = [
            'DOWNLOAD',
            'EDIT',
            'COPY',
            'DELETE',
            'PREVIEW',
        ];
        this.currentLanguage$ = this.store.select(skynet_store_languages_api_1.languageStateKey, 'currentLanguageId');
        this.exportTemplates$ = new BehaviorSubject_1.BehaviorSubject([]);
        this.reload$ = new BehaviorSubject_1.BehaviorSubject(undefined);
        this.actionTypeHandlers = {
            DOWNLOAD: this.download,
            EDIT: this.openTemplate,
            COPY: this.copy,
            DELETE: this.remove,
            PREVIEW: this.preview,
        };
    }
    Object.defineProperty(HeaderExportButtonComponent.prototype, "exportTemplates", {
        set: function (exportTemplates) {
            if (!lodash_1.isEmpty(exportTemplates)) {
                this.exportTemplates$.next(exportTemplates);
            }
        },
        enumerable: true,
        configurable: true
    });
    HeaderExportButtonComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (lodash_1.isNil(this.form) || lodash_1.isNil(this.form.metaForm)) {
            return;
        }
        this.authenticationService
            .getUserData()
            .pipe(operators_1.switchMap(function (userData) {
            return _this.authorizationService.getPermissionAccessValue(userData.userId, '963d7001-4e1e-4d79-866c-a0571bc27bbf');
        }))
            .subscribe(function (permissionValue) {
            _this._exportEditPermissionGranted =
                permissionValue.access === idm_authorization_client_js_1.Access.FULL;
        }, console.error);
        this.allTemplates$ = combineLatest_1.combineLatest(this.currentLanguage$.pipe(operators_1.switchMap(function (currentLanguage) {
            return _this.reload$.pipe(operators_1.switchMap(function () {
                return combineLatest_1.combineLatest(_this.exportTemplatesService.loadTemplatesDataByCategoryName(_this.categoryName, currentLanguage), _this.exportTemplatesService.loadPersonalizedTemplates(currentLanguage, Number(_this.form.metaForm.formId)));
            }));
        })), this.exportTemplates$.pipe(operators_1.switchMap(function (exportTemplates) {
            return _this.templatesAdditionalFilter
                ? _this.templatesAdditionalFilter.filter(exportTemplates, _this.categoryName, _this.entity)
                : Observable_1.Observable.of(exportTemplates);
        }))).pipe(operators_1.map(function (_a) {
            var _b = _a[0], templateViews = _b[0], templatesData = _b[1], exportTemplates = _a[1];
            var existingTemplates = new Map(templateViews.map(function (templateView) { return [templateView.id, templateView]; }));
            var dictionary = lodash_1.groupBy(templatesData.templateViews, function (temp) { return temp.originalTemplateUUId; });
            var result = [];
            exportTemplates
                .filter(function (exportTemplate) {
                return existingTemplates.has(exportTemplate.id);
            })
                .forEach(function (exportTemplate) {
                result.push({
                    id: exportTemplate.id,
                    name: existingTemplates.get(exportTemplate.id)
                        .name || '',
                    extension: exportTemplate.extension,
                    isPersonalized: false,
                });
                if (dictionary[exportTemplate.id]) {
                    dictionary[exportTemplate.id].sort(function (a, b) {
                        return a.createdOn.getDate() -
                            b.createdOn.getDate();
                    });
                    result.push.apply(result, dictionary[exportTemplate.id].map(template_utilities_1.formTemplateFromPersonalized));
                    delete dictionary[exportTemplate.id];
                }
            });
            result.push.apply(result, lodash_1.flatMap(lodash_1.values(dictionary), function (value) {
                return value.slice().sort(function (a, b) {
                    return a.createdOn.getDate() -
                        b.createdOn.getDate();
                })
                    .map(template_utilities_1.formTemplateFromPersonalized);
            }));
            return result;
        }));
    };
    HeaderExportButtonComponent.prototype.openTemplate = function (item) {
        var _this = this;
        if (this.formActions && this.formActions.editExportTemplate) {
            this.exportTemplatesService
                .loadPersonalizedTemplate(item.id)
                .pipe(operators_1.first(), operators_1.tap(function (template) {
                _this.formActions.editExportTemplate(template);
            }))
                .subscribe(noop_1.noop, function (e) { return LOGGER.error(e); });
        }
        this.matMenuTrigger.closeMenu();
    };
    HeaderExportButtonComponent.prototype.download = function (item) {
        this.previewDownload(item, true);
    };
    HeaderExportButtonComponent.prototype.preview = function (item) {
        this.previewDownload(item, false);
    };
    HeaderExportButtonComponent.prototype.copy = function (item) {
        var _this = this;
        var template$ = item.isPersonalized
            ? this.exportTemplatesService.loadPersonalizedTemplate(item.id)
            : this.exportTemplatesService.loadTemplate(item.id);
        template$
            .pipe(operators_1.switchMap(function (template) {
            return _this.matDialog
                .open(export_copy_template_dialog_component_1.ExportCopyTemplateDialogComponent, {
                disableClose: true,
                autoFocus: true,
                height: 'auto',
                width: '450px',
                data: template.name,
            })
                .afterClosed()
                .pipe(operators_1.first(), operators_1.switchMap(function (newName) {
                if (lodash_1.isNil(newName)) {
                    return of_1.of();
                }
                return _this.exportTemplatesService.createPersonalizedTemplate(new idm_export_templates_service_client_js_1.PersonalizedTemplate('', _this.categoryName, template.htmlTemplate, newName, template.description, -1, new Date(), item.isPersonalized
                    ? template
                        .originalTemplateUUId
                    : item.id, Number(_this.form.metaForm.formId), new Date(), template_utilities_1.extensionToExportType(item.extension).valueOf()));
            }));
        }), operators_1.take(1), operators_1.tap(function () { return _this.reload$.next(undefined); }))
            .subscribe(noop_1.noop, function (e) { return LOGGER.error(e); });
    };
    Object.defineProperty(HeaderExportButtonComponent.prototype, "exportEditPermissionGranted", {
        get: function () {
            return this._exportEditPermissionGranted;
        },
        enumerable: true,
        configurable: true
    });
    HeaderExportButtonComponent.prototype.remove = function (item) {
        var _this = this;
        this.matDialog
            .open(delete_confirm_dialog_component_1.DeleteConfirmDialogComponent, {
            disableClose: true,
            autoFocus: true,
            height: 'auto',
            width: '450px',
        })
            .afterClosed()
            .pipe(operators_1.first(), operators_1.switchMap(function (result) {
            if (result) {
                return _this.exportTemplatesService.deletePersonalizedTemplate(item.id);
            }
            else {
                return of_1.of();
            }
        }), operators_1.take(1), operators_1.tap(function () { return _this.reload$.next(undefined); }))
            .subscribe(noop_1.noop, function (e) { return LOGGER.error(e); });
    };
    HeaderExportButtonComponent.prototype.setIndex = function (i) {
        this.selectedIndex = i;
        this.adjustActionIndex(0);
    };
    HeaderExportButtonComponent.prototype.handleKeydown = function (keyboardEvent, items) {
        var direction = 0;
        switch (keyboardEvent.code) {
            case 'ArrowDown':
                this.selectedIndex =
                    (this.selectedIndex + items.length + 1) % items.length;
                break;
            case 'ArrowUp':
                this.selectedIndex =
                    (this.selectedIndex + items.length - 1) % items.length;
                break;
            case 'ArrowLeft':
                direction = -1;
                break;
            case 'ArrowRight':
                direction = 1;
                break;
            case 'Enter':
                this.actionTypeHandlers[this.actionType].call(this, items[this.selectedIndex]);
                break;
            default:
                return;
        }
        this.adjustActionIndex(direction);
    };
    HeaderExportButtonComponent.prototype.adjustActionIndex = function (direction) {
        var _this = this;
        var activeAction = this.actions.filter(function (x) { return x.rowIndex === _this.selectedIndex; });
        var currentIndex = this.allActionsTypes.findIndex(function (action) { return action === _this.actionType; });
        if (currentIndex < 0) {
            throw Error('Illegal state');
        }
        var isActive = function (actionType) {
            return skynet_store_utilities_1.notNil(activeAction.find(function (action) { return action.value === actionType; }));
        };
        if (direction === 0 && isActive(this.allActionsTypes[currentIndex])) {
            return;
        }
        do {
            currentIndex =
                direction !== 0
                    ? (currentIndex + direction + this.allActionsTypes.length) %
                        this.allActionsTypes.length
                    : 0;
        } while (!isActive(this.allActionsTypes[currentIndex]));
        this.actionType = this.allActionsTypes[currentIndex];
    };
    HeaderExportButtonComponent.prototype.previewDownload = function (item, downloadFile) {
        var _this = this;
        var template$ = item.isPersonalized
            ? this.exportTemplatesService.loadPersonalizedTemplate(item.id)
            : this.exportTemplatesService.loadTemplate(item.id);
        combineLatest_1.combineLatest(template$, this.exportDataLoader
            ? this.exportDataLoader.getExportData(this.categoryName, this.entity.getInstanceId())
            : of_1.of({}), this.currentLanguage$)
            .pipe(operators_1.first(), operators_1.mergeMap(function (_a) {
            var template = _a[0], data = _a[1], currentLanguage = _a[2];
            var exportCategoryDto = {
                categorySystemName: _this.categoryName,
                categoryItemId: _this.entity.getInstanceId(),
                languageId: currentLanguage,
                exportType: template_utilities_1.extensionToExportType(item.extension),
                layoutName: template.uuid,
                fileName: template.name.getValue(currentLanguage),
                classifiersSystemNames: [],
                timeZoneId: Intl.DateTimeFormat().resolvedOptions()
                    .timeZone,
                data: __assign({}, data, { QR_data: JSON.stringify({
                        formId: _this.form.metaForm.formId,
                        type: 'DE Form',
                        category: _this.form.metaForm.layoutModel
                            .category,
                        formName: _this.form.metaForm.layoutModel
                            .formName,
                        entityId: _this.entity.getInstanceId(),
                    }) }),
            };
            return downloadFile
                ? _this.exportService.exportWithCategory(exportCategoryDto)
                : _this.exportService.exportWithCategoryToResponse(exportCategoryDto, false);
        }), operators_1.first())
            .subscribe(downloadFile
            ? noop_1.noop
            : function (response) {
                response && template_utilities_1.previewDocument(response.body);
            }, function (e) { return LOGGER.error(e); });
        this.matMenuTrigger.closeMenu();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderExportButtonComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HeaderExportButtonComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderExportButtonComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderExportButtonComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderExportButtonComponent.prototype, "exportTemplates", null);
    __decorate([
        core_1.ViewChildren(helper_directive_1.HelperDirective),
        __metadata("design:type", core_1.QueryList)
    ], HeaderExportButtonComponent.prototype, "actions", void 0);
    __decorate([
        core_1.ViewChild(material_1.MatMenuTrigger),
        __metadata("design:type", material_1.MatMenuTrigger)
    ], HeaderExportButtonComponent.prototype, "matMenuTrigger", void 0);
    HeaderExportButtonComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'header-export-button',
            template: require('./header-export-button.component.html'),
        }),
        __param(5, core_1.Optional()),
        __param(6, core_1.Optional()),
        __metadata("design:paramtypes", [store_1.Store,
            idm_export_templates_service_client_js_1.ExportTemplatesService,
            idm_export_client_js_1.ExportService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_authorization_client_js_1.AuthorizationService,
            export_data_loader_service_1.ExportDataLoaderService,
            templates_additional_filter_service_1.TemplatesAdditionalFilterService,
            material_1.MatDialog])
    ], HeaderExportButtonComponent);
    return HeaderExportButtonComponent;
}());
exports.HeaderExportButtonComponent = HeaderExportButtonComponent;
//# sourceMappingURL=header-export-button.component.js.map